import * as React from "react";

import { InfoBoxTrigger } from "@/components/molecules";
import { NeedHelpBox2 } from "@/components/molecules/NeedHelpBox";
import { PageHeader } from "./PageHeader";

export type PageHeaderWithHelpProps = {
  includeLogo?: boolean;
};

export const PageHeaderWithHelp: React.FC<PageHeaderWithHelpProps> = ({ includeLogo }) => {
  return (
    <PageHeader
      includeLogo={includeLogo}
      prompt={
        <InfoBoxTrigger left white content={<NeedHelpBox2 />}>
          <span style={{ textDecoration: "underline" }}>Need help?</span>
        </InfoBoxTrigger>
      }
    />
  );
};
